const getActiveVariant = (variants, sku)=>sku && variants.find((variant)=>variant.sku === sku
    ) || variants[0]
;

export { getActiveVariant };
//# sourceMappingURL=get-active-variant.js.map
